export const PRODUCTION_ORIGIN = "https://wordfinder.yourdictionary.com";
